import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHeating: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.91 10.838C17.433 10.164 17 9.55 17 9c0-.4.9-2 1.8-3.5.3-.5.2-1.1-.3-1.4-.5-.3-1.1-.2-1.4.3l-.13.216C16.308 5.713 15 7.88 15 9c0 1.265.852 2.435 1.634 3.51l.066.09c.128.192.26.38.39.563.477.674.91 1.287.91 1.837 0 .4-.9 2-1.8 3.5-.3.5-.2 1.1.3 1.4.2.1.4.2.6.2.3 0 .6-.2.8-.4.7-1 2.2-3.4 2.2-4.6-.097-1.36-.95-2.532-1.733-3.607L18.3 11.4c-.128-.192-.26-.38-.39-.562zM6 9c0-.4.9-2 1.8-3.5.3-.4.2-1-.2-1.3-.5-.3-1.1-.2-1.4.2C5.5 5.4 4 7.8 4 9c0 1.264.852 2.434 1.635 3.51l.065.09c.128.192.26.38.39.562.477.675.91 1.287.91 1.838 0 .4-.9 2-1.8 3.5-.3.5-.2 1.1.3 1.4.041 0 .1.017.169.037.097.028.214.063.331.063.3 0 .6-.2.8-.4.7-1 2.2-3.4 2.2-4.6 0-1.265-.852-2.435-1.635-3.51L7.3 11.4c-.128-.192-.26-.38-.39-.563C6.433 10.163 6 9.55 6 9zm7.3-3.5C12.4 7 11.5 8.6 11.5 9c0 .55.433 1.163.91 1.838.13.182.262.37.39.562l.066.09c.782 1.075 1.634 2.245 1.634 3.51 0 1.2-1.5 3.6-2.2 4.6-.2.2-.5.4-.8.4-.117 0-.234-.034-.331-.063-.069-.02-.128-.037-.169-.037-.5-.3-.6-.9-.3-1.4.9-1.5 1.8-3.1 1.8-3.5 0-.55-.433-1.163-.91-1.838a24.43 24.43 0 01-.39-.562l-.066-.09C10.352 11.435 9.5 10.265 9.5 9c0-1.2 1.5-3.6 2.2-4.6.3-.4.9-.5 1.3-.3.5.3.6.9.3 1.4z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
